// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","user":"Header_user__vOhFY","orgLogo":"Header_orgLogo__Df8eD","info":"Header_info__hTX7k"};